import {Inject, Injectable} from '@angular/core';
import {ADMIN_URL} from '../../injection-tokens';
import {Observable} from 'rxjs';
import {ApiService, HttpMethod} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {

  constructor(private _apiService: ApiService,
              @Inject(ADMIN_URL) private _adminUrl: string) {
  }

  sendRequest<T>(endpoint: string, paramsObj: { requestBody?: {} } = {}, httpMethod: HttpMethod = 'GET'): Observable<T> {
    return this._apiService.sendRequest<T>(endpoint, httpMethod, paramsObj, this._adminUrl, false, true);
  }

  getGroups<T = any>(params): Observable<T> {
    return this.sendRequest('admin.console.getGroups', params);
  }

  createAdminInvitation<T = any>(params): Observable<T> {
    return this.sendRequest('admin.console.createAdminInvitation', params);
  }

  batchUpdateGroups<T = any>(params): Observable<T> {
    return this.sendRequest('admin.batchUpdateGroups', params);
  }

  deleteUser<T = any>(params): Observable<T> {
    return this.sendRequest('admin.console.deleteUser', params);
  }

  getSamlSettings<T = any>(params): Observable<T> {
    params = {
      ...params,
      isCDP: true
    };
    return this.sendRequest('admin.console.getSamlSettings', params);
  }

  setSamlSettings<T = any>(params): Observable<T> {
    params = {
      ...params,
      isCDP: true
    };
    return this.sendRequest('admin.console.setSamlSettings', params);
  }

  finalizeSamlLogin<T = any>(params): Observable<T> {
    return this.sendRequest('admin.console.finalizeSamlLogin', params);
  }
}
